module.exports = __webpack_public_path__ + "img/implantacao.c3890515.jpg";